'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isType = undefined;

var _curry = require('transmute/curry');

var _curry2 = _interopRequireDefault(_curry);

var _commonMessageFormatGetters = require('../../common-message-format/operators/commonMessageFormatGetters');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isType = exports.isType = (0, _curry2.default)(function (type, message) {
  return (0, _commonMessageFormatGetters.getType)(message) === type;
});


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/pubnub-message/operators/isType.js
// module id = 40
// module chunks = 2 3